import { getToken } from "@/utils/auth";
import service from "@/utils/request";

export const getAllDevelopers = async (page) => {
    try{
        const response = await service.get('/developers?page='+page);
        return response;
    }catch(e){
        console.error("Failed to fetch Units:", e);
    }
}

export const deleteDev = async (id) => {
    try{
        const response = await service.delete('/developers/'+id);
        return response;
    }catch(e){
        console.error("Failed to delete Developer:", e);
    }
}

export const UpdateDev = async ( developer) => {
    try{
        const response = await service.post('/developers/'+developer.id , developer);
        return response;
    }catch(e){
        console.error("Failed to update Unit:", e);
    }
}
export const addDeveloper = async (developer) => {
    try{
        const response = await service.post('/developers', developer, {
            headers: {
                'Authorization': `Bearer ${getToken()}`,
                'Content-Type': 'multipart/form-data',  // Important for file uploads
            }
        });
        return response;
    }catch(e){
        console.error("Failed to Add Developer:", e);
    }
}
export const search = async ( value , page) => {
    try{
        const response = await service.get('/developers?page='+page+'&search='+value);
        return response;
    }catch(e){
        console.error("Failed to update Unit:", e);
    }
}

